<template>
  <router-view></router-view>
</template>

<script>

export default {
  name: 'app',
  watch: {
    '$store.state.theme': {
      immediate: true,
      handler(theme) {
        this.applyTheme(theme);
      }
    }
  },
  methods: {
    applyTheme(theme) {
      const themeLink = document.getElementById('theme-css');

      if (theme === 'light') {
        if (themeLink) themeLink.remove();
        document.body.classList.remove('c-dark-theme');
      } else {
        let cssFile;
        if (theme === 'shockwave') {
          cssFile = './css/shockwave-theme.css';
        } else if (theme === 'bmw') {
          cssFile = './css/bmw-theme.css';
        } else {
          cssFile = './css/dark-theme.css';
        }

        if (themeLink) {
          themeLink.href = cssFile;
        } else {
          const link = document.createElement('link');
          link.id = 'theme-css';
          link.rel = 'stylesheet';
          link.href = cssFile;
          document.head.appendChild(link);
        }
        document.body.classList.add('c-dark-theme');
      }
    }
  }
}
</script>

<style lang="scss">
  // CoreUI Icons Set
  @import '~@coreui/icons/css/coreui-icons.min.css';
  /* Import Font Awesome Icons Set */
  $fa-font-path: '~font-awesome/fonts/';
  @import '~font-awesome/scss/font-awesome.scss';
  /* Import Simple Line Icons Set */
  $simple-line-font-path: '~simple-line-icons/fonts/';
  @import '~simple-line-icons/scss/simple-line-icons.scss';
  /* Import Flag Icons Set */
  @import '~flag-icon-css/css/flag-icon.min.css';
  /* Import Bootstrap Vue Styles */
  @import '~bootstrap-vue/dist/bootstrap-vue.css';
  // Import Main styles for this application
  @import 'assets/scss/style';

  // Linha selecionada (b-table selected-variant) legível nos temas escuros
  .c-dark-theme .table-primary,
  .c-dark-theme .table-primary > th,
  .c-dark-theme .table-primary > td,
  .c-dark-theme .table-hover .table-primary:hover,
  .c-dark-theme .table-hover .table-primary:hover > th,
  .c-dark-theme .table-hover .table-primary:hover > td {
    background-color: rgba(32, 168, 216, 0.35);
    color: #fff;
  }
  .c-dark-theme .table-primary .text-muted,
  .c-dark-theme .table-primary small {
    color: rgba(255, 255, 255, 0.85) !important;
  }
</style>
